/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { EnumEmailTransactionableSendStatusFromJSON, EnumEmailTransactionableSendStatusToJSON } from './EnumEmailTransactionableSendStatus';
export function ChatMessageContactEmailTransactionFromJSON(json) {
    return ChatMessageContactEmailTransactionFromJSONTyped(json, false);
}
export function ChatMessageContactEmailTransactionFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: !exists(json, 'id') ? undefined : json['id'],
        sendStatus: !exists(json, 'send_status')
            ? undefined
            : EnumEmailTransactionableSendStatusFromJSON(json['send_status'])
    };
}
export function ChatMessageContactEmailTransactionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        send_status: EnumEmailTransactionableSendStatusToJSON(value.sendStatus)
    };
}
